import React, { useState } from 'react'
import { Link, useLoaderData, useOutletContext } from 'react-router-dom';
import useAuthStore from  '../../store/auth';
import { warningAlert } from '../../utils/alert';
import { formatDate } from '../../utils/methods';
import { uploadAvatar } from '../../adapters/profle';


export default function MyProfile() {
  const profileData = useLoaderData();
  const user = useAuthStore((state) => state.user);

  const { logout: signOut, refreshToken: refreshAuth  } = useOutletContext();

  const logout = () => {
    warningAlert("Are you sure you want to Sign out", "", () => {
      signOut();
    })
  }

  const [ updating, setUpdating ] = useState(false);

  const changeAvatar = (value) => {
    setUpdating(true);
    uploadAvatar({
      file: value[0]
    }).then((res) => {
      if(res.status === 200) {
        refreshAuth();
      }
      setUpdating(false)
    })
  }
  
  return (
    <div className="relative">
      <div className="wrapper-2 animate__animated animate__fadeIn">
        <div className="md:mt-36 mt-24 bg-gray-100 py-6 px-4 lg:px-8 rounded-t-2xl rounded-lg border-2 border-gray-300">
          <div className="relative w-2/5 md:w-1/5 -mt-24 mx-auto">
            <img src={user.avatar} alt={user.name} className="w-full rounded-full"  />
            <label className="absolute flex justify-center text-gray-900 items-center h-full w-full cursor-pointer  rounded-full blue-bg-light hover:opacity-100 opacity-0 focus:opacity-100 top-0">
              <span>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
                  <path fillRule="evenodd" d="M1.5 6a2.25 2.25 0 012.25-2.25h16.5A2.25 2.25 0 0122.5 6v12a2.25 2.25 0 01-2.25 2.25H3.75A2.25 2.25 0 011.5 18V6zM3 16.06V18c0 .414.336.75.75.75h16.5A.75.75 0 0021 18v-1.94l-2.69-2.689a1.5 1.5 0 00-2.12 0l-.88.879.97.97a.75.75 0 11-1.06 1.06l-5.16-5.159a1.5 1.5 0 00-2.12 0L3 16.061zm10.125-7.81a1.125 1.125 0 112.25 0 1.125 1.125 0 01-2.25 0z" clipRule="evenodd" />
                </svg>
              </span>
              {!updating && <input type="file" name="avatar" onChange={(e) => changeAvatar(e.target.files)} className="hidden" />}
            </label>
          </div>
          <div className="mt-3 text-center border-b border-blue-800 pb-3 mx-6">
            <h4 className="text-xl font-semibold">{user.name}</h4>
            <a href={`mailto:${user.email}`} className="text-xs text-blue-900 font-semibold">{user.email}</a> <br />
            <a href={`tel:${user.phone}`} className="text-xs text-blue-900 font-semibold">{profileData?.profile?.phone}</a>
          </div>

          <div className="grid md:grid-cols-2 mt-5 grid-cols-1 md:gap-6 gap-6 md:px-8 px-4">
            <div className="text-gray-200 py-4 blue-bg rounded-xl relative">
            <Link to="/account/profile/edit/personal" className="absolute bg-white shadow-md text-blue-900 hover:bg-blue-100 rounded-lg -top-3 -right-3 p-2">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
                <path d="M21.731 2.269a2.625 2.625 0 00-3.712 0l-1.157 1.157 3.712 3.712 1.157-1.157a2.625 2.625 0 000-3.712zM19.513 8.199l-3.712-3.712-8.4 8.4a5.25 5.25 0 00-1.32 2.214l-.8 2.685a.75.75 0 00.933.933l2.685-.8a5.25 5.25 0 002.214-1.32l8.4-8.4z" />
                <path d="M5.25 5.25a3 3 0 00-3 3v10.5a3 3 0 003 3h10.5a3 3 0 003-3V13.5a.75.75 0 00-1.5 0v5.25a1.5 1.5 0 01-1.5 1.5H5.25a1.5 1.5 0 01-1.5-1.5V8.25a1.5 1.5 0 011.5-1.5h5.25a.75.75 0 000-1.5H5.25z" />
              </svg>
            </Link>
              <h4 className="text-white text-lg ml-4 font-semibold font-fira">Personal Info</h4>
              <div className="border-b mt-2 border-gray-300 py-3 px-6">
                <h4 className="text-xs">Name</h4>
                <h4 className="font-semibold text-sm">{`${profileData?.profile.firstname} ${profileData?.profile.lastname} ${profileData?.profile.othername}`}</h4>
              </div>

              <div className="border-b border-gray-300 py-4 px-6">
                <h4 className="text-xs">Date Of Birth</h4>
                <h4 className="font-semibold text-sm">{formatDate(profileData?.profile.dateOfBirth)}</h4>
              </div>

              <div className="border-b border-gray-300 py-3 px-6">
                <h4 className="text-xs">Location</h4>
                <h4 className="font-semibold text-sm">{profileData?.profile.country}  <span>{profileData?.profile.state}</span></h4>
              </div>

              <div className="py-3 px-6">
                <h4 className="text-xs">Religion</h4>
                <h4 className="font-semibold text-sm"><span>{profileData?.profile.religion}</span></h4>
              </div>
            </div>

            <div className="text-gray-200 py-4 blue-bg rounded-xl relative">
              <Link to="/account/profile/edit/employment" className="absolute bg-white shadow-md text-blue-900 hover:bg-blue-100 rounded-lg -top-3 -right-3 p-2">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
                  <path d="M21.731 2.269a2.625 2.625 0 00-3.712 0l-1.157 1.157 3.712 3.712 1.157-1.157a2.625 2.625 0 000-3.712zM19.513 8.199l-3.712-3.712-8.4 8.4a5.25 5.25 0 00-1.32 2.214l-.8 2.685a.75.75 0 00.933.933l2.685-.8a5.25 5.25 0 002.214-1.32l8.4-8.4z" />
                  <path d="M5.25 5.25a3 3 0 00-3 3v10.5a3 3 0 003 3h10.5a3 3 0 003-3V13.5a.75.75 0 00-1.5 0v5.25a1.5 1.5 0 01-1.5 1.5H5.25a1.5 1.5 0 01-1.5-1.5V8.25a1.5 1.5 0 011.5-1.5h5.25a.75.75 0 000-1.5H5.25z" />
                </svg>
              </Link>
              <h4 className="text-white text-lg ml-4 font-semibold font-fira">Employment Info</h4>
              <div className="border-b mt-2 border-gray-300 py-3 px-6">
                <h4 className="text-xs">Education Level</h4>
                <h4 className="font-semibold text-sm">{`${profileData?.profile.education}`}</h4>
              </div>

              <div className="border-b mt-2 border-gray-300 py-3 px-6">
                <h4 className="text-xs">Occupation</h4>
                <h4 className="font-semibold text-sm">{`${profileData?.profile.occupation}`}</h4>
              </div>
              

              <div className="border-b border-gray-300 py-3 px-6">
                <h4 className="text-xs">Employment Status</h4>
                <h4 className="font-semibold text-sm">{profileData?.profile.empoymentStatus}  <span>{profileData?.profile.state}</span></h4>
              </div>

              <div className="py-3 px-6">
                <h4 className="text-xs">Average Income</h4>
                <h4 className="font-semibold text-sm"><span>{profileData?.profile.averageIncome}</span></h4>
              </div>
            </div>

            <div className="text-gray-200 col-span-1 md:col-span-2 py-4 blue-bg rounded-xl relative">
              {/* <Link to="/account/profile/edit/settings" className="absolute bg-white shadow-md text-blue-900 hover:bg-blue-100 rounded-lg -top-3 -right-3 p-2">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
                  <path d="M21.731 2.269a2.625 2.625 0 00-3.712 0l-1.157 1.157 3.712 3.712 1.157-1.157a2.625 2.625 0 000-3.712zM19.513 8.199l-3.712-3.712-8.4 8.4a5.25 5.25 0 00-1.32 2.214l-.8 2.685a.75.75 0 00.933.933l2.685-.8a5.25 5.25 0 002.214-1.32l8.4-8.4z" />
                  <path d="M5.25 5.25a3 3 0 00-3 3v10.5a3 3 0 003 3h10.5a3 3 0 003-3V13.5a.75.75 0 00-1.5 0v5.25a1.5 1.5 0 01-1.5 1.5H5.25a1.5 1.5 0 01-1.5-1.5V8.25a1.5 1.5 0 011.5-1.5h5.25a.75.75 0 000-1.5H5.25z" />
                </svg>
              </Link> */}
              <h4 className="text-white text-lg ml-4 font-semibold font-fira">Account Info</h4>
              <div className="border-b border-gray-300 py-3 px-6">
                <h4 className="text-xs">Email</h4>
                <h4 className="font-semibold text-sm">{`${profileData?.email}`}</h4>
              </div>

              <div className="border-b border-gray-300 py-3 px-6">
                <h4 className="text-xs">Phone</h4>
                <h4 className="font-semibold text-sm">{profileData?.profile.phone}</h4>
              </div>

              <div className="py-3 px-6">
                <h4 className="text-xs">Date Joined</h4>
                <h4 className="font-semibold text-sm"><span>{user.createdAt}</span></h4>
              </div>
            </div>
          </div>

          <div className="mt-6 px-4">
            <Link to="/account/profile/edit/setting" className="flex justify-start items-center hover: py-4 gap-2 border-b hover:bg-blue-200 px-2 cursor-pointer border-blue-800">
              <span>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
                  <path fillRule="evenodd" d="M11.828 2.25c-.916 0-1.699.663-1.85 1.567l-.091.549a.798.798 0 01-.517.608 7.45 7.45 0 00-.478.198.798.798 0 01-.796-.064l-.453-.324a1.875 1.875 0 00-2.416.2l-.243.243a1.875 1.875 0 00-.2 2.416l.324.453a.798.798 0 01.064.796 7.448 7.448 0 00-.198.478.798.798 0 01-.608.517l-.55.092a1.875 1.875 0 00-1.566 1.849v.344c0 .916.663 1.699 1.567 1.85l.549.091c.281.047.508.25.608.517.06.162.127.321.198.478a.798.798 0 01-.064.796l-.324.453a1.875 1.875 0 00.2 2.416l.243.243c.648.648 1.67.733 2.416.2l.453-.324a.798.798 0 01.796-.064c.157.071.316.137.478.198.267.1.47.327.517.608l.092.55c.15.903.932 1.566 1.849 1.566h.344c.916 0 1.699-.663 1.85-1.567l.091-.549a.798.798 0 01.517-.608 7.52 7.52 0 00.478-.198.798.798 0 01.796.064l.453.324a1.875 1.875 0 002.416-.2l.243-.243c.648-.648.733-1.67.2-2.416l-.324-.453a.798.798 0 01-.064-.796c.071-.157.137-.316.198-.478.1-.267.327-.47.608-.517l.55-.091a1.875 1.875 0 001.566-1.85v-.344c0-.916-.663-1.699-1.567-1.85l-.549-.091a.798.798 0 01-.608-.517 7.507 7.507 0 00-.198-.478.798.798 0 01.064-.796l.324-.453a1.875 1.875 0 00-.2-2.416l-.243-.243a1.875 1.875 0 00-2.416-.2l-.453.324a.798.798 0 01-.796.064 7.462 7.462 0 00-.478-.198.798.798 0 01-.517-.608l-.091-.55a1.875 1.875 0 00-1.85-1.566h-.344zM12 15.75a3.75 3.75 0 100-7.5 3.75 3.75 0 000 7.5z" clipRule="evenodd" />
                </svg>
              </span>
              <span className="font-semibold text-sm">
                Settings
              </span>
            </Link>

            <a href='mailto:support@northmeadgroup.com' className="flex justify-start items-center hover: py-4 gap-2 border-b hover:bg-red-200 px-2 cursor-pointer border-blue-800">
              <span>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
                  <path fillRule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm11.378-3.917c-.89-.777-2.366-.777-3.255 0a.75.75 0 01-.988-1.129c1.454-1.272 3.776-1.272 5.23 0 1.513 1.324 1.513 3.518 0 4.842a3.75 3.75 0 01-.837.552c-.676.328-1.028.774-1.028 1.152v.75a.75.75 0 01-1.5 0v-.75c0-1.279 1.06-2.107 1.875-2.502.182-.088.351-.199.503-.331.83-.727.83-1.857 0-2.584zM12 18a.75.75 0 100-1.5.75.75 0 000 1.5z" clipRule="evenodd" />
                </svg>
              </span>
              <span className="font-semibold text-sm">
                Support
              </span>
            </a>

            <div onClick={logout} className="flex justify-start items-center hover: py-4 gap-2 border-b hover:bg-red-200 px-2 cursor-pointer border-blue-800">
              <span>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
                  <path fillRule="evenodd" d="M7.5 3.75A1.5 1.5 0 006 5.25v13.5a1.5 1.5 0 001.5 1.5h6a1.5 1.5 0 001.5-1.5V15a.75.75 0 011.5 0v3.75a3 3 0 01-3 3h-6a3 3 0 01-3-3V5.25a3 3 0 013-3h6a3 3 0 013 3V9A.75.75 0 0115 9V5.25a1.5 1.5 0 00-1.5-1.5h-6zm10.72 4.72a.75.75 0 011.06 0l3 3a.75.75 0 010 1.06l-3 3a.75.75 0 11-1.06-1.06l1.72-1.72H9a.75.75 0 010-1.5h10.94l-1.72-1.72a.75.75 0 010-1.06z" clipRule="evenodd" />
                </svg>
              </span>
              <span className="font-semibold text-sm">
                Sign Out
              </span>
            </div>
          </div>

        </div>
      </div>
    </div>
  )
}


